// extracted by mini-css-extract-plugin
export default {"YoutubeEmbed":"bbo_a"};